import { FormGroup } from 'reactstrap'
import { RadioButtonGroup } from 'common-components'

const GenderSelection = ({ genderOptions, gender, selectGender }) => (
  <FormGroup id="insured-gender-selection" className="gender-selection">
    <label>เพศตามกำเนิด</label>
    <RadioButtonGroup
      value={gender}
      options={genderOptions}
      onChange={selectGender}
      classNamePrefix="gender"
      autoClassName={true}
    />
  </FormGroup>
)

export default GenderSelection
